(function ($) {

  const initializeBlock = function ($block) {

  }

  $(document).ready(function () {
    $('.block--form-with-content').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=form-with-content', initializeBlock);
  }

})(jQuery);